<script lang="ts">
  import type { OrgaViewFrameContext } from "../../context"
  import FeedbackTable from "@kontextwerk/control-web-frame/shared/modules/feedback-table"
  import { getAdminApi } from "../../../../api/kehrblatt/client"

  const { viewFrameContext } = $props<{ viewFrameContext: OrgaViewFrameContext }>()
  const organization = $derived(viewFrameContext.organization)
</script>

{#if organization}
  <FeedbackTable
    title="Feedback"
    fetchFeedback={(params) => getAdminApi().feedback.listForOrg(organization.id, params)}
    showUser={true}
    refreshKey={viewFrameContext.refreshKey}
    createOrganizationId={organization.id}
    onFeedbackCreated={viewFrameContext.onFeedbackCreated}
  />
{/if}
